export default {
  CREATE_ON_BOARDING_REPOSITORY: Symbol.for('CREATE_ON_BOARDING_REPOSITORY'),
  CREATE_ON_BOARDING_COMMAND: Symbol.for('CREATE_ON_BOARDING_COMMAND'),
};
